<template>
  <div>
    <app-breadcrumb />
    <div class="card mb-1">
      <div class="card-body p-1">
        <b-row>
          <div class="col-12 col-md-2">
            <b-form-group label="Từ ngày">
              <flat-pickr
                v-model="start_date"
                class="form-control"
                :config="config_time"
                placeholder="dd-mm-yyyy"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group label="Đến ngày">
              <flat-pickr
                v-model="end_date"
                class="form-control"
                :config="config_time"
                placeholder="dd-mm-yyyy"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group label="Danh mục">
              <v-select
                v-model="channel_group_id"
                :options="dataCategory"
                label="Name"
                :reduce="(val) => val.Id"
                placeholder="--Chọn--"
              />
            </b-form-group>
          </div>
          <div class="col-12 col-md-2">
            <b-form-group label="Thể loại">
              <v-select
                v-model="type"
                :options="dataType"
                label="name"
                :reduce="(val) => val.code"
                placeholder="--Chọn--"
              />
            </b-form-group>
          </div>
          <b-col
            cols="12"
            md="4"
          >
            <b-form-group label="Tìm kiếm">
              <b-input-group>
                <b-form-input
                  v-model="localSearchQuery"
                  class="d-inline-block"
                  placeholder="Tên danh mục"
                  @keyup.enter="updateSearchQuery"
                />
                <b-input-group-append>
                  <b-button
                    variant="danger"
                    @click="updateSearchQuery"
                  >
                    <feather-icon icon="SearchIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </div>
    </div>
    <!-- List -->
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-card
        class="p-0"
        no-body
      >
        <b-table
          ref="refListTable"
          :items="dataItems"
          responsive
          :fields="tableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching records found"
        >
          <template #cell(title)="data">
            <span
              class="title"
              @click="handlePreview(data.item)"
            ><b>{{ data.item.title }}</b></span>
          </template>
          <template #cell(type)="data">
            <span v-if="data.item.type == 'video'">Video</span>
            <span v-else>Audio</span>
          </template>
          <template #cell(status)="data">
            <span
              v-if="data.item.status"
              class="badge badge-light-success"
            >Đang kích hoạt</span>
            <span
              v-else
              class="badge badge-light-danger"
            >Đang dừng</span>
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              class=""
              variant="warning"
              @click="edit(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="EditIcon" />
              </span>
            </b-button>
            <b-button
              size="sm"
              class="ms-2"
              variant="danger"
              @click="onDestroy(data.item)"
            >
              <span class="text-nowrap">
                <feather-icon icon="TrashIcon" />
              </span>
            </b-button>
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted">{{ $t('show_to_entries', { from: dataMeta.from, to: dataMeta.to, of: dataMeta.of, }) }}</span>
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="total"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon
                    icon="ChevronLeftIcon"
                    size="18"
                  />
                </template>
                <template #next-text>
                  <feather-icon
                    icon="ChevronRightIcon"
                    size="18"
                  />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-modal
        id="modalDownload"
        no-close-on-backdrop
        hide-footer
        title="Xem file ghi lại"
      >
        <download-dialog :item="item" />
      </b-modal>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCard,
  BOverlay,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BFormCheckbox,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BFormGroup,
  BLink,
} from 'bootstrap-vue';
import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';
import AppBreadcrumb from '@core/layouts/components/AppBreadcrumb.vue';
import vSelect from 'vue-select';
import flatPickr from 'vue-flatpickr-component';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import { showToast } from '@/@core/utils/utils';
import ChannelGroupForm from './ChannelGroupForm.vue';
import DownloadDialog from './DownloadDialog.vue'

export default {
  components: {
    BOverlay,
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BPagination,
    BInputGroupAppend,
    AppBreadcrumb,
    BInputGroup,
    BFormCheckbox,
    ChannelGroupForm,
    BFormGroup,
    BLink,
    vSelect,
    flatPickr,
    DownloadDialog,
  },
  data() {
    return {
      item: {},
    }
  },
  setup() {
    const refListTable = ref(null);
    const tableColumns = [
      {
        key: 'id', sortable: false, label: 'ID', thAttr: { width: '6%' },
      },
      { key: 'title', sortable: false, label: 'Tiêu đề' },
      { key: 'filename', sortable: false, label: 'Filename' },
      {
        key: 'category_name', sortable: false, label: 'Danh mục', thAttr: { width: '10%' },
      },
      {
        key: 'type', sortable: false, label: 'Thể loại', thAttr: { width: '10%' },
      },
      {
        key: 'created_at', sortable: false, label: 'Ngày thu', thAttr: { width: '10%' },
      },
    ];
    const perPage = ref(30);
    const total = ref(0);
    const currentPage = ref(1);
    const perPageOptions = [10, 25, 50, 100];
    const searchQuery = ref('');
    const localSearchQuery = ref('');
    const loading = ref(true);
    const dataItems = ref([]);
    const dataCategory = ref([])
    const start_date = ref('');
    const end_date = ref('');
    const dataType = ref([])
    const type = ref('');
    const channel_group_id = ref('')

    const fetchAll = () => {
      loading.value = false;
      store
        .dispatch('channel/fetchall', {
          keyword: searchQuery.value,
          perPage: perPage.value,
          page: currentPage.value,
          card_type: 'schedule_item',
          start_date: start_date.value,
          end_date: end_date.value,
          channel_group_id: channel_group_id.value,
          type: type.value,
        })
        .then((response) => {
          loading.value = false;
          const result = response.data;
          if (result.code === 200) {
            dataItems.value = result.data.data
            dataCategory.value = result.data.channelGroup
            dataType.value = result.data.dataType
          }
        });
    };
    const dataMeta = computed(() => {
      const localItemsCount = refListTable.value ? refListTable.value.localItems.length : 0;
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: total.value,
      };
    });
    fetchAll();
    watch([currentPage, perPage, searchQuery, type, channel_group_id], () => {
      refetchData();
    });

    const refetchData = () => {
      fetchAll();
    };

    const updateSearchQuery = () => {
      searchQuery.value = localSearchQuery.value;
      if (start_date.value && start_date.value > end_date.value) {
        showToast('Đến ngày phải lớn hớn từ ngày');
        return false;
      }
      refetchData()
    };
    const config_time = ref({
      dateFormat: 'd-m-Y',
      wrap: true,
      locale: Vietnamese, // locale for this instance only
    });
    return {
      loading,
      dataItems,
      perPage,
      tableColumns,
      perPage,
      currentPage,
      total,
      dataMeta,
      perPageOptions,
      refListTable,
      refetchData,
      updateSearchQuery,
      localSearchQuery,
      config_time,
      start_date,
      end_date,
      dataCategory,
      dataType,
      channel_group_id,
      type,
    };
  },
  methods: {
    handlePreview(item) {
      this.item = item
      this.$bvModal.show('modalDownload')
    },
  },
};
</script>
<style lang="scss">
.col-form-label {
  font-size: 0.95rem;
}

@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
